/* * 地图图层点击事件 -弹框显示 * @module components/mapbase/MapToolTip * @desc 用于地图弹框显示 *
@author zhaoting * @date 2019年12月17日 * @param {Array} [center] - 地图默认中心坐标 * @param
{Number} [zoom] - 地图缩放级别 */
<script>
export default {
  name: 'MapToolTip',
  components: {},
  props: {},
  data() {
    return {
      map: {},
    };
  },
  mounted() {
    // this.initMapClick();
  },
  created() {
    this.configmap = config.map;
  },
  methods: {
    initInfo() {},
  },
};
</script>

<template>
  <div></div>
</template>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/mapbase/MapTooTip.vue